import { render, staticRenderFns } from "./MilestoneTemplateDetailEditForm.vue?vue&type=template&id=b21e996e"
import script from "./MilestoneTemplateDetailEditForm.vue?vue&type=script&lang=js"
export * from "./MilestoneTemplateDetailEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports